"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m8.59 6.29a.5.5 0 0 1 -.59-.57.5.5 0 0 1 .57-.56.5.5 0 0 1 .56.56.5.5 0 0 1 -.56.57zm-2.29 0a.5.5 0 0 1 -.57-.57.5.5 0 0 1 .57-.56.5.5 0 0 1 .57.56.5.5 0 0 1 -.56.57zm-2.3 0a.5.5 0 0 1 -.57-.57.5.5 0 0 1 .57-.56.5.5 0 0 1 .57.56.5.5 0 0 1 -.57.57zm20 1.15v-1.72a2.52 2.52 0 0 0 -2.85-2.85h-18.27a2.74 2.74 0 0 0 -2 .83 2.75 2.75 0 0 0 -.84 2v1.74z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m24 18.28v-9.7h-24v9.7a2.75 2.75 0 0 0 .84 2 2.74 2.74 0 0 0 2 .83h18.3a2.52 2.52 0 0 0 2.86-2.83z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "m5.65 11.39a.31.31 0 1 0 0 .62.31.31 0 1 0 0-.62z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m18.92 19.72a.39.39 0 0 1 -.26.34.39.39 0 0 0 .26-.34v-3.6z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m6.9 11.39a.31.31 0 1 0 0 .62.31.31 0 0 0 0-.62z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m8.15 11.39a.31.31 0 1 0 0 .62.31.31 0 0 0 0-.62z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m16.92 17.32a.39.39 0 0 0 -.36-.38.39.39 0 0 1 .36.38v2.79z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m20.46 15.5a.39.39 0 0 0 -.17-.14l-2.17-1.57 2.17 1.57a.39.39 0 0 1 .17.14z"
  })), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m15.72 11.47a1.07 1.07 0 0 1 .63.2l.21.16v-.13a1.38 1.38 0 0 0 -1.56-1.56h-10a1.55 1.55 0 0 0 -1.53 1.56v.94h10.3l1.33-1a1.07 1.07 0 0 1 .62-.17zm-10.07.53a.31.31 0 1 1 0-.62.31.31 0 1 1 0 .62zm1.26 0a.31.31 0 1 1 0-.62.31.31 0 0 1 0 .62zm1.24 0a.31.31 0 1 1 0-.62.31.31 0 0 1 0 .62z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m11.87 16.79h-.53a1.07 1.07 0 0 1 -.63-1.93l2.21-1.6h-9.45v5.29a1.53 1.53 0 0 0 .46 1.11 1.5 1.5 0 0 0 1.07.45h7a1 1 0 0 1 -.08-.39z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m15.19 17.59v2.5a1.44 1.44 0 0 0 1.07-.5v-2z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m20.46 15.5a.39.39 0 0 0 -.17-.14l-2.17-1.57-1.58-1.15-.54-.43a.4.4 0 0 0 -.24-.07.39.39 0 0 0 -.23.07l-4.43 3.19a.4.4 0 0 0 .24.72h1.19v3.6a.39.39 0 0 0 .4.39h1.6v-2.79a.4.4 0 0 1 .4-.4h1.59a.39.39 0 0 1 .36.38v2.79h1.6a.39.39 0 0 0 .14-.05.39.39 0 0 0 .26-.34v-3.6h1.21a.39.39 0 0 0 .28-.11.4.4 0 0 0 .12-.28.45.45 0 0 0 -.03-.21z",
    fill: "#fff"
  }));
};

exports["default"] = _default;